import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material';
import _ from 'lodash';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { ConfiguracionProducto } from 'src/app/global/interfaces/configuracion-producto';
import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { ProveedorServicio } from 'src/app/global/interfaces/proveedor-servicios';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { configuracionProducto, rut } from 'src/app/messages/step-2-messages';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { correoValidator } from 'src/app/view-model/validators/correo.validator';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';
import { rutValidator } from 'src/app/view-model/validators/rut.validator';


@Component({
  selector: 'app-configuracion-producto-pj',
  templateUrl: './configuracion-producto-pj.component.html',
  styleUrls: ['./configuracion-producto-pj.component.scss']
})
export class ConfiguracionProductoPJComponent {

  get flujosPJ() { return this.flujosPaso2PJServ; }

  constructor(private carroService: CarroComprasService,
    private productoServiceVM: vmProductosService,
    private rutFormatter: RutFormatterService,
    private productService: vmProductosService,
    private datosPersonalesService: DatosPersonalesService,
    private tagM: TagManagerService,
    private flujosPaso2PJServ: FlujosPaso2PJService,
    private storage: LocalStorageService) { }

  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;
  cantidadCamposEditables = 0;
  clickTimeout = null;
  conLimite: boolean;
  created = false;
  edicion = true;
  guardar: boolean;
  isPersonaNatural: boolean = false;
  labelCampos = '';
  loading = false;
  onOff: string;
  preFill: DatosPersonales = null;
  processing = false;
  producto: Product;
  requiereContacto: boolean;
  requiereLimiteMonto: boolean;
  requiereNombreLinkPago: boolean;
  requiereRecibeNotificaciones: boolean;
  requiereTecnico: boolean;
  requiereURL: boolean;
  requiereURLObligatorio: boolean;
  savedData: ConfiguracionProducto = null;
  showDatosTecnico: boolean;
  validacionCaso: string;
  yoRecibo: boolean = false;
  requiereProveedorServicio: boolean;
  proveedores: ProveedorServicio[] = [];
  idProveedor: number;

  @Input() showCantidadCampos = true;
  @Output() paso3Ok: EventEmitter<any> = new EventEmitter();

  public mensajesConfiguracionProductoPJ = configuracionProducto;

  public messageRutError = {
    txtRut: [
      { type: 'required', message: rut.REQUIRED_RUT_MESSAGE },
      { type: 'dniInvalid', message: rut.INVALID_RUT_MESSAGE }
    ]
  };

  public configProductos = new FormGroup({
    txtRut: new FormControl('', [
      Validators.required,
      rutValidator
    ]),
    nombrePago: new FormControl('', [Validators.required, Validators.minLength(4)]),
    nombre: new FormControl('', [Validators.required]),
    apellido: new FormControl('', [Validators.required]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')]),
    correoElectronico: new FormControl('', [Validators.required,
      correoValidator]),
    rangoHasta: new FormControl('', [])
  });

  public urlFormOpcional = new FormGroup({
    url: new FormControl('', Validators.pattern(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}/))
  });

  public urlFormObligatorio = new FormGroup({
    url: new FormControl('', [Validators.required, Validators.pattern(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}/)])
  });

  public configProdInd = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    apellido: new FormControl('', [Validators.required]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')]),
    correoElectronico: new FormControl('', [Validators.required,
      correoValidator])
  });

  public configProdTransbank = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    apellido: new FormControl('', [Validators.required]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')]),
    correoElectronico: new FormControl('', [Validators.required,
      correoValidator])
  });

  public proveedorServicio = new FormGroup({
    idProveedor: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')])
  });

  on() {
    this.conLimite = true;
    this.onOff = 'on';
    // this.cantidadCamposEditables = 7;
    this.completarCampos(7);
  }

  off() {
    this.conLimite = false;
    this.onOff = 'off';
    this.configProductos.get('rangoHasta').setValue(null);
    // this.cantidadCamposEditables = 6;
    this.completarCampos(6);
  }

  init() {
    this.created;
    this.producto = this.carroService.getCurrentProduct();
    this.inicializarVista();
    this.validacionCaso = this.producto.codigoProducto;
    this.conLimite = false;
    this.onOff = 'off';
    this.guardar = true;
    this.obtenerDatosPersonalesSocio();
    this.obtenerConfiguracionProducto();
    // this.completarCampos();
  }

  private obtenerDatosPersonalesSocio() {
    //Obtener datos personales del primer socio (orden = 1) o en su defecto el primero con Correo.
    this.preFill = this.storage.getPaso2().datosSocios.filter(socio => socio.orden !== null).reduce((menor, actual) =>
      actual.orden < menor.orden ? actual : menor
    ) || this.storage.getPaso2().datosSocios.find(soc => soc.correo);

    const intRun = Number(this.preFill.run);
    let dv = null;
    if (intRun) {
      dv = this.rutFormatter.getDv(intRun);
      this.preFill.run = `${intRun}-${dv}`;
    }
  }

  selectPST(idComercioPST) {
    this.idProveedor = Number(idComercioPST);
    this.proveedorServicio.patchValue({
      idProveedor: this.idProveedor
    });
  }

  async obtenerConfiguracionProducto() {

    const fnSuccess = async (resp: ConfiguracionProducto) => {

      this.edicion = (await this.validaEdicion()).data;
      this.flujosPaso2PJServ.configuracionProducto.bloqueado = false;
      if (this.producto.codigoProducto === CodigoProductoEnum.COBRO_QR) {
        this.flujosPaso2PJServ.configuracionProducto.cargando = false;
        this.flujosPaso2PJServ.configuracionProducto.mostrar = false;
        this.flujosPaso2PJServ.configuracionProducto.ok = true;
        this.flujosPaso2PJServ.configuracionProducto.visible = false;
        this.paso3Ok.emit();
        return;
      }

      switch (this.producto.codigoProducto) {
        case CodigoProductoEnum.LINK_PAGO:
        case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
        case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
        case CodigoProductoEnum.PACK_POS_MOVIL_LP:
          this.savedData = resp.contacto != null ? resp : null;
          this.checkIfSavedDataEqualsToaddress();
          if (this.configProductos.valid) {
            this.flujosPaso2PJServ.configuracionProducto.cargando = false;
            this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
            this.flujosPaso2PJServ.configuracionProducto.ok = true;
            this.paso3Ok.emit();
            return;
          }
          break;
        default:
          break;
      }

      if (this.producto.codigoProducto === CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX) {
        if (resp.urlSitio) {
          this.urlFormOpcional.get('url').setValue(String(_.get(resp, 'urlSitio', '')).replace('www.', ''));
          if (this.urlFormOpcional.valid) {
            this.flujosPaso2PJServ.configuracionProducto.cargando = false;
            this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
            this.flujosPaso2PJServ.configuracionProducto.ok = true;
            this.paso3Ok.emit();
          }
        }
      }
      if (this.producto.codigoProducto === CodigoProductoEnum.INTEGRADOR_TRANSBANK) {
        this.setIntegradorTransbank(resp);
        if (this.configProdTransbank.valid && this.urlFormObligatorio.valid) {
          this.flujosPaso2PJServ.configuracionProducto.cargando = false;
          this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
          this.flujosPaso2PJServ.configuracionProducto.ok = true;
          this.paso3Ok.emit();
          return;
        }
      }
      if (this.producto.codigoProducto === CodigoProductoEnum.INTEGRADOR_CLIENTE) {
        this.setIntegradorCliente(resp);
        if (this.configProdInd.valid && this.urlFormObligatorio.valid) {
          this.flujosPaso2PJServ.configuracionProducto.cargando = false;
          this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
          this.flujosPaso2PJServ.configuracionProducto.ok = true;
          this.paso3Ok.emit();
          return;
        }
      }
      if (this.producto.codigoProducto === CodigoProductoEnum.CREACION_SITIO_PST) {
        this.urlFormOpcional.get('url').setValue(String(_.get(resp, 'urlSitio', '')).replace('www.', ''));
        this.idProveedor = _.get(resp, 'idProveedor');
        this.proveedorServicio.get('idProveedor').setValue(String(this.idProveedor));
        if (this.proveedorServicio.valid) {
          this.flujosPaso2PJServ.configuracionProducto.cargando = false;
          this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
          this.flujosPaso2PJServ.configuracionProducto.ok = true;
          this.paso3Ok.emit();
        }
      }

      if (!this.edicion) {
        this.flujosPaso2PJServ.configuracionProducto.cargando = false;
        this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
        this.flujosPaso2PJServ.configuracionProducto.ok = true;
        this.paso3Ok.emit();
        return;
      }

      this.flujosPaso2PJServ.configuracionProducto.cargando = false;
      this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
    };

    const fnFailure = (error) => {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    };


    this.productoServiceVM.obtenerConfiguracionProducto().subscribe(fnSuccess, fnFailure);
  }

  private setIntegradorCliente(resp: ConfiguracionProducto) {
    // this.cantidadCamposEditables = 5;
    this.completarCampos(5);
    this.configProdInd.get('nombre').setValue(_.get(resp, 'contacto.nombres.nombres', ''));
    this.configProdInd.get('apellido').setValue(_.get(resp, 'contacto.nombres.apellidoPaterno', ''));
    this.configProdInd.get('telefono').setValue(_.get(resp, 'contacto.telefono', ''));
    this.configProdInd.get('correoElectronico').setValue(_.get(resp, 'contacto.correo', ''));
    if (resp.urlSitio) {
      this.urlFormObligatorio.get('url').setValue(String(_.get(resp, 'urlSitio', '')).replace('www.', ''));
    }
  }

  private setIntegradorTransbank(resp: ConfiguracionProducto) {
    // this.cantidadCamposEditables = 5;
    this.completarCampos(5);
    this.configProdTransbank.get('nombre').setValue(_.get(resp, 'contacto.nombres.nombres', ''));
    this.configProdTransbank.get('apellido').setValue(_.get(resp, 'contacto.nombres.apellidoPaterno', ''));
    this.configProdTransbank.get('telefono').setValue(_.get(resp, 'contacto.telefono', ''));
    this.configProdTransbank.get('correoElectronico').setValue(_.get(resp, 'contacto.correo', ''));

    if (resp.urlSitio) {
      this.urlFormObligatorio.get('url').setValue(String(_.get(resp, 'urlSitio', '')).replace('www.', ''));
    }
  }

  private setLinkPago(resp: ConfiguracionProducto) {
    // this.cantidadCamposEditables = 6;
    this.completarCampos(6);
    const intRun = _.get(resp, 'contacto.run', null);
    let dv = null;
    let run = '';
    let montoMaximo = '';
    if (intRun) {
      dv = this.rutFormatter.getDv(intRun);
      run = `${intRun}-${dv}`;
    }
    if (resp.montoMaximo > 0) {
      this.on();
      montoMaximo = this.addMiles(String(resp.montoMaximo));
    } else {
      this.off();
    }
    this.configProductos.get('txtRut').setValue(run);
    this.configProductos.get('nombrePago').setValue(_.get(resp, 'nombrePago', ''));
    this.configProductos.get('nombre').setValue(_.get(resp, 'contacto.nombres.nombres', ''));
    this.configProductos.get('apellido').setValue(_.get(resp, 'contacto.nombres.apellidoPaterno', ''));
    this.configProductos.get('telefono').setValue(_.get(resp, 'contacto.telefono', ''));
    this.configProductos.get('correoElectronico').setValue(_.get(resp, 'contacto.correo', ''));
    this.configProductos.get('rangoHasta').setValue(montoMaximo);
  }

  addMiles(value: string): string {
    const valueReturn = value
      .replace(/[^0-9]/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return valueReturn;
  }

  private inicializarVista() {
    switch (this.producto.codigoProducto) {
      case CodigoProductoEnum.LINK_PAGO:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
      case CodigoProductoEnum.PACK_POS_MOVIL_LP:
        this.requiereURL = false;
        this.requiereURLObligatorio = false;
        this.requiereNombreLinkPago = true;
        this.requiereTecnico = false;
        this.requiereContacto = false;
        this.requiereRecibeNotificaciones = true;
        this.requiereProveedorServicio = false;
        break;
      case CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX:
        this.requiereURL = true;
        this.requiereURLObligatorio = false;
        this.requiereLimiteMonto = false;
        this.requiereNombreLinkPago = false;
        this.requiereTecnico = false;
        this.requiereContacto = false;
        this.requiereProveedorServicio = false;
        this.requiereRecibeNotificaciones = false;
        break;
      case CodigoProductoEnum.INTEGRADOR_TRANSBANK:
        this.showDatosTecnico = false;
        this.requiereURL = false;
        this.requiereURLObligatorio = true;
        this.requiereTecnico = false;
        this.requiereContacto = true;
        this.requiereNombreLinkPago = false;
        this.requiereProveedorServicio = false;
        this.requiereRecibeNotificaciones = false;
        break;
      case CodigoProductoEnum.INTEGRADOR_CLIENTE:
        this.showDatosTecnico = false;
        this.requiereURL = false;
        this.requiereURLObligatorio = true;
        this.requiereTecnico = true;
        this.requiereContacto = false;
        this.requiereNombreLinkPago = false;
        this.requiereProveedorServicio = false;
        this.requiereRecibeNotificaciones = false;
        break;
      case CodigoProductoEnum.CREACION_SITIO_PST:
        this.requiereURL = false;
        this.requiereURLObligatorio = false;
        this.requiereLimiteMonto = false;
        this.requiereNombreLinkPago = false;
        this.requiereTecnico = false;
        this.requiereContacto = false;
        this.requiereRecibeNotificaciones = false;
        this.requiereProveedorServicio = true;
        break;
      default:
        break;
    }
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (error) {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }

  ContinuarGuardar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.guardarConfiguracionProducto();
      }, 100);
    }

  }

  async guardarConfiguracionProducto() {
    this.loading = true;
    if (!this.guardar) {
      return;
    } else {
      this.guardar = false;
    }

    if (this.producto.codigoProducto === CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX) {
      if (this.urlFormOpcional.get('url').value === '') {
        this.flujosPaso2PJServ.configuracionProducto.cargando = false;
        this.flujosPaso2PJServ.configuracionProducto.mostrar = true;
        this.flujosPaso2PJServ.configuracionProducto.ok = true;
        this.paso3Ok.emit();
        return;
      }
    }

    const data: any = this.prepararBody();

    const cbOK = async response => {
      this.registraSeleccionProducto();
      this.loading = false;
      this.guardar = true;
      if (!this.flujosPaso2PJServ.datosAdjuntos.mostrar) {
        this.flujosPaso2PJServ.configuracionProducto.ok = true;
        this.paso3Ok.emit();
      } else {
        this.matExpansion.close();
      }
      this.tagM.logDL_cofiguracionProducto(this.producto, this.configProductos);
      this.processing = false;
      this.matExpansion.close();
    };

    const cbError = error => {
      this.loading = false;
      console.error('Error configuracion producto: ', error);
      this.guardar = true;
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.processing = false;
    };

    this.productoServiceVM.postConfiguracionProducto(data).subscribe(cbOK, cbError);
  }

  validaEdicion(): Promise<GeneralResponse<boolean>> {
    return new Promise((resolve, reject) => {
      const fnSuccess = (edicion: GeneralResponse<boolean>) => {
        resolve(edicion);
      };

      const fnFailure = (error) => {
        console.error(error);
        reject(error);
      };

      this.datosPersonalesService.validaEdicion().subscribe(fnSuccess, fnFailure);
    });
  }

  private prepararBody(): any {
    let body: any;
    let montoString: string;
    let monto: number;
    let url: string;

    switch (this.producto.codigoProducto) {
      case CodigoProductoEnum.INTEGRADOR_CLIENTE:
        body = {
          montoMinimo: null,
          montoMaximo: null,
          contacto: {
            run: null,
            nombres: {
              nombres: this.configProdInd.get('nombre').value,
              apellidoPaterno: this.configProdInd.get('apellido').value,
              apellidoMaterno: null
            },
            correo: this.configProdInd.get('correoElectronico').value,
            telefono: Number(this.configProdInd.get('telefono').value)
          },
          urlSitio: 'www.' + this.urlFormObligatorio.get('url').value,
          nombrePago: null
        };
        break;
      case CodigoProductoEnum.INTEGRADOR_TRANSBANK:
        body = {
          montoMinimo: null,
          montoMaximo: null,
          contacto: {
            run: null,
            nombres: {
              nombres: this.configProdTransbank.get('nombre').value,
              apellidoPaterno: this.configProdTransbank.get('apellido').value,
              apellidoMaterno: null
            },
            correo: this.configProdTransbank.get('correoElectronico').value,
            telefono: Number(this.configProdTransbank.get('telefono').value)
          },
          urlSitio: 'www.' + this.urlFormObligatorio.get('url').value,
          nombrePago: null
        };
        break;
      case CodigoProductoEnum.LINK_PAGO:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
      case CodigoProductoEnum.PACK_POS_MOVIL_LP:
        if (this.conLimite) {
          montoString = this.configProductos.get('rangoHasta').value;
          montoString = montoString.split('.').join('');
          monto = Number(montoString);
        }
        // const monto: number = Number(_.replace(this.configProductos.get('rangoHasta').value, new RegExp('.', 'g'), ''));
        const run: number = this.rutFormatter.getRutFormats(this.configProductos.get('txtRut').value).numbers;
        body = {
          montoMinimo: null,
          montoMaximo: this.conLimite ? monto : null,
          contacto: {
            run,
            nombres: {
              nombres: this.configProductos.get('nombre').value,
              apellidoPaterno: this.configProductos.get('apellido').value,
              apellidoMaterno: 'Apellido Materno'
            },
            correo: this.configProductos.get('correoElectronico').value,
            telefono: Number(this.configProductos.get('telefono').value)
          },
          urlSitio: null,
          nombrePago: this.configProductos.get('nombrePago').value
        };
        break;
      case CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX:
        url = 'www.' + this.urlFormOpcional.get('url').value;
        body = {
          montoMinimo: null,
          montoMaximo: null,
          contacto: null,
          urlSitio: url.length > 4 ? url : null,
          nombrePago: null
        };
        break;
      case CodigoProductoEnum.CREACION_SITIO_PST:
        url = 'www.' + this.urlFormOpcional.get('url').value;
        body = {
          urlSitio: url.length > 4 ? url : null,
          idProveedor: Number(this.proveedorServicio.get('idProveedor').value)
        };
        break;
    }
    return body;
  }

  private completarCampos(camposEditables: number) {
    if (this.producto.codigoProducto !== CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX) {
      this.labelCampos = 'Completa sólo ' + camposEditables + ' datos';
    }
  }

  /**
   * Metodo que permite conocer si el usuario destinario de recepcion de Notificacion de Link de pago es el mismo que la persona que contrata
   */
  checkIfSavedDataEqualsToaddress() {
    if (this.savedData != null && this.savedData.contacto != null) {
      if (this.savedData.contacto.correo == this.preFill.correo
        && this.savedData.contacto.run == Number(this.preFill.run)
        && this.savedData.contacto.telefono == this.preFill.telefono
        && this.savedData.contacto.nombres.nombres == this.preFill.nombre.nombres
        && this.savedData.contacto.nombres.apellidoPaterno == this.preFill.nombre.apellidoPaterno) {
        this.yoReciboBtn();
      } else {
        this.otraPersonaBtn();
      }
    } else {
      this.yoReciboBtn();
    }
  }

  public otraPersonaBtn() {
    this.yoRecibo = false;
    if (this.savedData) {
      this.setLinkPago(this.savedData);
    } else {
      this.configProductos.get('txtRut').setValue(null);
      this.configProductos.get('nombre').setValue(null);
      this.configProductos.get('apellido').setValue(null);
      this.configProductos.get('telefono').setValue(null);
      this.configProductos.get('correoElectronico').setValue(null);
      this.configProductos.get('nombrePago').setValue(null);
      this.configProductos.get('rangoHasta').setValue(null);
    }
  }

  public yoReciboBtn() {
    this.yoRecibo = true;
    this.configProductos.get('txtRut').setValue(this.preFill.run);
    this.configProductos.get('nombre').setValue(this.preFill.nombre.nombres);
    this.configProductos.get('apellido').setValue(this.preFill.nombre.apellidoPaterno);
    this.configProductos.get('telefono').setValue(this.preFill.telefono);
    this.configProductos.get('correoElectronico').setValue(this.preFill.correo);
  }
}
